module.exports = __webpack_public_path__ + "img/business7E.b8b5602b.png";